<template>
  <div id="app">
    <b-navbar v-if="isLoggedIn && isServerAvailable" :style="styleObject" toggleable="md" type="dark" variant="dark" fixed="top">
      <b-button size="sm" v-b-toggle.sidebar-1 class="mr-3">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </b-button>
      <b-navbar-brand v-b-toggle.sidebar-1>WITORA</b-navbar-brand>

      <b-sidebar
        id="sidebar-1"
        title="Меню"
        shadow
        no-enforce-focus
        no-close-on-route-change
        v-model="isOpenMenu"
        width="240px"
      >
        <b-list-group id="menu" flush class="menu text-small">
          <b-list-group-item :to="{ path: '/home'}" :class="$route.name === 'Home' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="home" style="color: darkorange" class="mr-1"/>
            Личный кабинет
          </b-list-group-item>
          <b-list-group-item v-if="hasPermTask" :to="{ name: 'Tasks'}" :class="$route.name === 'Tasks' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="tasks" style="color: darkgreen" class="mr-1"/>
            {{ $t("message.tasks.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermWorker" :to="{ path: '/workers'}" :class="$route.path === '/workers' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="people-carry" style="color: darkblue" class="mr-1"/>
            {{ $t("message.workers.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCustomer" :to="{ path: '/customers'}" :class="$route.path === '/customers' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="user-tie" style="color: darkred" class="mr-1"/>
            {{ $t("message.customers.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermLocation" :to="{ path: '/locations'}" :class="$route.path === '/locations' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="map-marked-alt" style="color: green" class="mr-1"/>
            {{ $t("message.locations.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermOrganization" :to="{ path: '/organizations'}" :class="$route.path === '/organizations' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="building" style="color: darkred" class="mr-1"/>
            Организации
          </b-list-group-item>
        </b-list-group>

        <b-list-group v-if="hasPermStaff" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/invoices'}" :class="$route.path === '/invoices' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="file-invoice-dollar" style="color: darkviolet" class="mr-1"/>
            Выставление счёта
          </b-list-group-item>
          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/reconciliation_acts'}" :class="$route.path === '/reconciliation_acts' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="file-contract" style="color: darksalmon" class="mr-1"/>
            Акты сверки
          </b-list-group-item>
        </b-list-group>

        <b-list-group v-if="hasPermRecruit" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-b-toggle:collapse-recruit :variant="navVariant">
            <font-awesome-icon icon="people-arrows" style="color: royalblue" class="mr-1"/>
            Подбор
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>

          <b-collapse id="collapse-recruit">
            <b-list-group-item v-if="hasPermRecruitTask" :to="{ path: '/recruit_tasks'}" :class="$route.path === '/recruit_tasks' && 'active router-link-active'" :variant="navVariant">Заявки</b-list-group-item>
          </b-collapse>
          <b-collapse id="collapse-recruit">
            <b-list-group-item v-if="hasPermRecruitJobPosting" :to="{ path: '/recruit_job_postings'}" :class="$route.path === '/recruit_job_postings' && 'active router-link-active'" :variant="navVariant">Объявления</b-list-group-item>
          </b-collapse>
          <b-collapse id="collapse-recruit">
            <b-list-group-item v-if="hasPermLocationVacancy" :to="{ path: '/recruit_location_vacancies'}" :class="$route.path === '/recruit_location_vacancies' && 'active router-link-active'" :variant="navVariant">Шаблоны вакансий</b-list-group-item>
          </b-collapse>

        </b-list-group>

        <b-list-group v-if="hasPermStaff" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/staffs'}" :class="$route.path === '/staffs' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="id-card" style="color: black" class="mr-1"/>
            Персонал
          </b-list-group-item>

          <!--          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/accruals'}" :class="$route.path === '/accruals' && 'active router-link-active'" :variant="navVariant">-->
          <!--            <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>-->
          <!--            Начисления зарплаты-->
          <!--          </b-list-group-item>-->
          <!--          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/salaries'}" :class="$route.path === '/salaries' && 'active router-link-active'" :variant="navVariant">-->
          <!--            <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>-->
          <!--            Выплаты зарплаты-->
          <!--          </b-list-group-item>-->
          <!--          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/salary_summary'}" :class="$route.path === '/salary_summary' && 'active router-link-active'" :variant="navVariant">-->
          <!--            <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>-->
          <!--            Зарплатная ведомость-->
          <!--          </b-list-group-item>-->

        </b-list-group>

        <b-list-group flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-if="hasPermStatistic" v-b-toggle:collapse-statistics :variant="navVariant">
            <font-awesome-icon icon="chart-pie" style="color: darkcyan" class="mr-1"/>
            Статистика
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>

          <b-collapse id="collapse-statistics">
            <b-list-group-item :to="{ name: 'ManagerStatistics'}" :class="$route.name === 'ManagerStatistics' && 'active router-link-active'" :variant="navVariant">По менеджерам</b-list-group-item>
            <b-list-group-item :to="{ name: 'CustomerStatistics'}" :class="$route.name === 'CustomerStatistics' && 'active router-link-active'" :variant="navVariant">По заказчикам</b-list-group-item>
          </b-collapse>

          <b-list-group-item v-if="hasPermRegister" v-b-toggle:collapse-register :variant="navVariant">
            <font-awesome-icon icon="chart-bar" style="color: darkmagenta" class="mr-1"/>
            Реестры
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>
          <b-collapse id="collapse-register">
            <b-list-group-item :to="{ name: 'Register'}" :class="$route.name === 'Register' && 'active router-link-active'" :variant="navVariant">Общий</b-list-group-item>
          </b-collapse>

          <b-list-group-item
            v-if="hasPermAnalytic"
            :to="{ path: '/analytics'}" :class="$route.path === '/analytics' && 'active router-link-active'"
            :variant="navVariant"
          >
            <font-awesome-icon icon="chart-line" style="color: darkorange" class="mr-1"/>
            Аналитика
          </b-list-group-item>

          <b-list-group-item v-if="hasPermReport" :to="{ path: '/reports'}" :class="$route.path === '/reports' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="table" style="color: darkslateblue" class="mr-1"/>
            Отчёты
          </b-list-group-item>
        </b-list-group>

        <b-list-group flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-if="hasPermUser" :to="{ path: '/users'}" :class="$route.path === '/users' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="users" class="mr-1"/>
            Пользователи
          </b-list-group-item>

          <b-list-group-item v-if="hasPermRole" :to="{ path: '/user_roles'}" :class="$route.path === '/user_roles' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="user-cog" class="mr-1"/>
            Роли
          </b-list-group-item>

          <b-list-group-item v-if="hasPermCatalog" v-b-toggle:collapse-catalogs :variant="navVariant">
            <font-awesome-icon icon="list" style="color: darkgray" class="mr-1"/>
            Справочники
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>
          <b-collapse id="collapse-catalogs">
            <b-list-group-item v-if="hasPermCatalogTown" :to="{ path: '/town_catalogs'}" :class="$route.path === '/town_catalogs' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Города
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogCitizenship" :to="{ path: '/citizenships'}" :class="$route.path === '/citizenships' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Гражданства
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogWorkType" :to="{ path: '/work_type_catalogs'}" :class="$route.path === '/work_type_catalogs' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Виды работ
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogSource" :to="{ path: '/marketing_sources'}" :class="$route.path === '/marketing_sources' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Маркетинговые источники
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogWorkerSource" :to="{ path: '/worker_sources'}" :class="$route.path === '/worker_sources' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Источники исполнителей
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogWorkerStatus" :to="{ path: '/worker_statuses'}" :class="$route.path === '/worker_statuses' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Статусы исполнителей
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogEmploymentCategory" :to="{ path: '/employment_categories'}" :class="$route.path === '/employment_categories' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Категория занятости
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogDriverLicenseCategory" :to="{ path: '/driver_license_categories'}" :class="$route.path === '/driver_license_categories' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Категории водительских прав
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogJobTitle" :to="{ path: '/job_titles'}" :class="$route.path === '/job_titles' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Должности
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogLocationCostType" :to="{ path: '/location_cost_types'}" :class="$route.path === '/location_cost_types' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Типы расходов объекта
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogLocationStatus" :to="{ path: '/location_statuses'}" :class="$route.path === '/location_statuses' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Статусы объекта
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogWorkerCostType" :to="{ path: '/worker_cost_types'}" :class="$route.path === '/worker_cost_types' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Типы расходов исполнителя
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogDepartment" :to="{ path: '/departments'}" :class="$route.path === '/departments' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Подразделения
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogWorkService" :to="{ path: '/work_services'}" :class="$route.path === '/work_services' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Услуги самозанятых
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogVacancy" :to="{ path: '/vacancies'}" :class="$route.path === '/vacancies' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Вакансии
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogProjectStatus" :to="{ path: '/project_statuses'}" :class="$route.path === '/project_statuses' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Статусы проектов
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogLeadStatus" :to="{ path: '/lead_statuses'}" :class="$route.path === '/lead_statuses' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Статусы лидов
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogCustomerStatus" :to="{ path: '/customer_statuses'}" :class="$route.path === '/customer_statuses' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Статусы заказчиков
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogLeadSource" :to="{ path: '/lead_sources'}" :class="$route.path === '/lead_sources' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Источники лидов
            </b-list-group-item>
            <b-list-group-item v-if="hasPermCatalogRecruitTag" :to="{ path: '/recruit_tags'}" :class="$route.path === '/recruit_tags' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="list" style="color: darkgrey" class="mr-1"/>
              Теги заявки на подбор
            </b-list-group-item>
          </b-collapse>
        </b-list-group>
      </b-sidebar>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <em>{{user.name}}</em>
          </template>
          <b-dropdown-item @click="logout">{{ $t("message.login.logout") }}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <div v-else-if="!isLoggedIn && !isServerAvailable">
      <router-view/>
    </div>

    <div class="navbar-height" :style="styleObject">
      <router-view/>
    </div>

    <ErrorsModalWindow :offline="noConnectionError" :not-found="notFoundError" :forbidden="forbiddenError" v-model="showErrorModal"/>

    <portal-target name="app"/>
  </div>
</template>

<script>
import ErrorsModalWindow from './components/Alerts/ErrorsModalWindow.vue'
import permissions from "./utilites/permissions";
import {PERM} from "./utilites/permissions";
import { EventBus } from './utilites/eventBus'

export default {
  name: 'App',
  components: { ErrorsModalWindow },
  mixins: [permissions],
  data () {
    return {
      user: "",
      navVariant: "",
      isOpenMenu: true,
      styleObject: {
        marginLeft: '0px',
      },
      isServerAvailable: true,
      noConnectionError: false,
      notFoundError: false,
      forbiddenError: false,
      showErrorModal: false,
      check: null,
    }
  },
  created() {
    this.configureView();
    window.addEventListener('online', this.checkServerStatus);
    window.addEventListener('offline', this.checkServerStatus);

    EventBus.$on('http-error-404', () => {
      this.forbiddenError = false;
      this.noConnectionError = false;
      this.notFoundError = true;
      this.showErrorModal = true;
    });

    EventBus.$on('http-error-403', () => {
      this.notFoundError = false;
      this.noConnectionError = false;
      this.forbiddenError = true;
      this.showErrorModal = true;
    });
  },
  mounted() {
    if (this.isLoggedIn && this.$route.name !== 'Login') {
      this.userInfo();
    }

    this.checkServerStatus();
    this.check = setInterval(() => {
      this.checkServerStatus();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.check);
    window.removeEventListener('online', this.checkServerStatus);
    window.removeEventListener('offline', this.checkServerStatus);
    EventBus.$off('http-error-404');
    EventBus.$off('http-error-403');
  },
  methods: {
    checkServerStatus() {
      const isOnline = window.navigator.onLine

      if (!isOnline) {
        this.isServerAvailable = false;
        this.noConnectionError = true;
        this.showErrorModal = true;
        return;
      }

      this.$http.get("ping").then( result => {
        if (result.status === 200) {
          this.isServerAvailable = true;
          this.noConnectionError = false;
          this.showErrorModal = false;
        }
      }, error => {
        this.isServerAvailable = false;
        this.noConnectionError = true;
        this.showErrorModal = true;
      });
    },
    configureView() {
      let style = {
        marginLeft: '0px',
        transition: 'margin 300ms ease-in-out'
      };
      if (this.isOpenMenu) {
        style = {
          marginLeft: '240px',
          transition: 'margin 300ms ease-in-out'
        };
      }
      this.styleObject = style;
    },
    logout() {
      this.$store.dispatch("logout").then(res => {
        this.user= "";
        this.$router.push('/login').catch(()=>{});
      })
    },
    userInfo() {
      this.$http.get("users/info").then(result => {
        if (result.status === 200) {
          this.user = result.body;
          this.$store.dispatch("updatePermissions", {
            role: result.body.role,
            permissions: result.body.permissions,
          }).then();
        }
      }, error => {
        console.log(error);
      });
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    hasPermCatalog() {
      return this.hasPermission([PERM.CATALOG])
    },
    hasPermCatalogTown() {
      return this.hasPermission([PERM.CATALOG_TOWN])
    },
    hasPermCatalogCitizenship() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS])
    },
    hasPermCatalogWorkType() {
      return this.hasPermission([PERM.CATALOG_WORK_TYPE])
    },
    hasPermCatalogSource() {
      return this.hasPermission([PERM.CATALOG_SOURCE])
    },
    hasPermCatalogWorkerSource() {
      return this.hasPermission([PERM.CATALOG_WORKER_SOURCE])
    },
    hasPermCatalogEmploymentCategory() {
      return this.hasPermission([PERM.CATALOG_EMPLOYMENT_CATEGORY])
    },
    hasPermCatalogDriverLicenseCategory() {
      return this.hasPermission([PERM.CATALOG_DRIVER_LICENSE_CATEGORY])
    },
    hasPermCatalogJobTitle() {
      return this.hasPermission([PERM.CATALOG_JOB_TITLE])
    },
    hasPermCatalogLocationCostType() {
      return this.hasPermission([PERM.CATALOG_LOCATION_COST_TYPE])
    },
    hasPermCatalogLocationStatus() {
      return this.hasPermission([PERM.CATALOG_LOCATION_STATUS])
    },
    hasPermCatalogWorkerCostType() {
      return this.hasPermission([PERM.CATALOG_WORKER_COST_TYPE])
    },
    hasPermCatalogDepartment() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT])
    },
    hasPermCatalogWorkService() {
      return this.hasPermission([PERM.CATALOG_WORK_SERVICE])
    },
    hasPermCatalogVacancy() {
      return this.hasPermission([PERM.CATALOG_VACANCY])
    },
    hasPermCatalogLeadStatus() {
      return this.hasPermission([PERM.CATALOG_LEAD_STATUS])
    },
    hasPermCatalogWorkerStatus() {
      return this.hasPermission([PERM.CATALOG_WORKER_STATUS])
    },
    hasPermCatalogProjectStatus() {
      return this.hasPermission([PERM.CATALOG_PROJECT_STATUS])
    },
    hasPermCatalogCustomerStatus() {
      return this.hasPermission([PERM.CATALOG_CUSTOMER_STATUS])
    },
    hasPermCatalogLeadSource() {
      return this.hasPermission([PERM.CATALOG_LEAD_SOURCE])
    },
    hasPermCatalogRecruitTag() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_TAG])
    },
    hasPermWorker() {
      return this.hasPermission([PERM.WORKER])
    },
    hasPermTask() {
      return this.hasPermission([PERM.TASK])
    },
    hasPermCustomer() {
      return this.hasPermission([PERM.CUSTOMER])
    },
    hasPermLocation() {
      return this.hasPermission([PERM.LOCATION])
    },
    hasPermLocationVacancy() {
      return this.hasPermission([PERM.LOCATION_VACANCY])
    },
    hasPermOrganization() {
      return this.hasPermission([PERM.ORGANIZATION])
    },
    hasPermRecruit() {
      return this.hasPermission([PERM.RECRUIT])
    },
    hasPermRecruitTask() {
      return this.hasPermission([PERM.RECRUIT_TASK])
    },
    hasPermRecruitJobPosting() {
      return this.hasPermission([PERM.RECRUIT_JOB_POSTING])
    },
    hasPermUser() {
      return this.hasPermission([PERM.USER])
    },
    hasPermRole() {
      return this.hasPermission([PERM.ROLE])
    },
    hasPermStaff() {
      return this.hasPermission([PERM.STAFF])
    },
    hasPermReport() {
      return this.hasPermission([PERM.REPORT])
    },
    hasPermRegister() {
      return this.hasPermission([PERM.REGISTER])
    },
    hasPermAnalytic() {
      return this.hasPermission([PERM.ANALYTIC])
    },
    hasPermStatistic() {
      return this.hasPermission([PERM.STATISTIC])
    },
  },
  watch: {
    "isOpenMenu": {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.configureView();
        }
      },
      deep: true
    },
    isLoggedIn: {
      handler: function (newVal) {
        if (newVal) {
          this.userInfo();
        } else {
          this.user = "";
        }
        this.isOpenMenu = newVal !== undefined ? newVal : true;
      }
    },
    '$route'() {
      this.showErrorModal = false;
    },
  }
}
</script>

<style>

/* ZIndex */
.topZIndex{
  z-index: 1050;
}

/* Text */
.text-small {
  font-size: smaller;
}

/* Collapsed */
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

/* Menu */
.menu .list-group-item {
  border: none;
}

/* NavBar */
@media (max-width: 575.98px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// Small devices (landscape phones, 576px and up)*/
@media (min-width: 576px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// Large devices (desktops, 992px and up)*/
@media (min-width: 992px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// X-Large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// XX-Large devices (larger desktops, 1400px and up)*/
@media (min-width: 1400px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/* Vertical divider */
.vr {
  border:         none;
  border-left:    1px solid hsla(200, 10%, 50%,100);
  height:         50%;
  width:          1px;
}

/* Pagination */
#pagination ul {
  margin-bottom: 0;
}

#pagination {
  margin-bottom: 0;
}

.pagination {
  margin-bottom: 0 !important;
}

/* Table */
.table-centered td {
  text-align: center;
  vertical-align: middle;
}

.table-centered th {
  text-align: center;
  vertical-align: middle;
}

.pointer-cell {
  cursor: pointer;
}

/* Table Sticky */
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
  border-top: 0;
}

.b-table-sticky-header {
  max-height: calc(100vh - 218.8px) !important;
  min-height: 300px;
}

.b-table-sticky-header > .table.b-table > tfoot > tr > th {
  position: sticky !important;
  bottom: 0;
  border-bottom: 0;
}


/* Content Sticky Header */
#header {
  top: 56px;
  position: sticky;
  z-index: 1020;
}

/* Content Sticky Footer */
#footer {
  position: sticky;
  bottom: 0;
}

/* Content Sticky Filters */
#filters {
  position: sticky;
  top: 87px;
  z-index: 5;
  background-color: white;
}

/* Model Content Padding */
.modal-body-select {
  padding: 0 !important
}

/* Model Content Sticky */
.modal-sticky {
  max-height: calc(100vh - 300.8px) !important;
}

/* Model Content Sticky Filters */
#modal-filters {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: white;
}

/* Autocomplete Select Input */
.autocomplete-input {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 2000;
}

/* Autocomplete Select Input Group Item */
.autocomplete-input .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue